import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';
import BaseFirewall from '../../AbstractObjects/GatewayPlan/InnerPages/BaseFirewall';
import {useTranslation} from 'react-i18next';
import Indentation from '../../../../components/Simple/Indentation';
import SMCLink from '../../../../components/Simple/SMCLink';
import {doSeamlessLogin} from '../../../../utils/utils';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {firewallIcon} from "../../../../assets/images/headerIcons";


const pageSchema = GatewayGetSchema.pages.firewall;
const pageId = pageSchema.pageId;

function GatewayFirewall({
    gatewayObject,
    planObject,
    setGatewayData,
    setEditorPageId
}) {
    const { t } = useTranslation();

    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const setPageValue = useCallback((param, newValue) => {
        setGatewayData([pageId, param], newValue);
    }, [setGatewayData]);


    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields\
        if (!locked) {
            setPageValue(pageSchema.manageInSmp, planPage[pageSchema.manageInSmp]);
            setPageValue(pageSchema.mode, planPage[pageSchema.mode]);
            setPageValue(pageSchema.policy, planPage[pageSchema.policy]);
            setPageValue(pageSchema.logBlockedTraffic, planPage[pageSchema.logBlockedTraffic]);
            setPageValue(pageSchema.logBlockedTrafficValue, planPage[pageSchema.logBlockedTrafficValue]);
            setPageValue(pageSchema.logAllowedTraffic, planPage[pageSchema.logAllowedTraffic]);
            setPageValue(pageSchema.logAllowedTrafficValue, planPage[pageSchema.logAllowedTrafficValue]);
        }
        setPageValue(pageSchema.lockedToPlan, locked);
    }, [setPageValue, planPage]);


    return (
        <>
            <LockToPlanContainer
                locked={lockedToPlan}
                onToggleLocked={onToggleLockedToPlan}
                labelText={t('SMP.GATEWAYS.INNER_MENU.FIREWALL')}
                icon={firewallIcon}
            >
                <BaseFirewall
                    pageData={currentPageData}
                    setObjectData={setGatewayData}
                    pageDisabled={lockedToPlan}
                    setEditorPageId={setEditorPageId}
                />
            </LockToPlanContainer>
            <Indentation>
                <SMCLink onClick={() => doSeamlessLogin(gatewayObject.id, null, 'app.FWOverview')}><SMCIcon style={{ verticalAlign: 'middle' }} icon="seamlessLogin" /> {t('SMP.ACCESS_GATEWAY.FIREWALL')}</SMCLink>
            </Indentation>
        </>
    );
}

export default GatewayFirewall;